import { z } from 'zod';
/**
 * Bentuk navigasi yang dikirim `GET /v1/me/nav`.
 *
 * Peta §7: "Navigasi disusun dari manifest modul, tidak ditulis tetap di kode.
 * Modul yang tidak dibeli tidak terlihat sama sekali — bukan menu mati."
 * Karena itu konsol tidak punya daftar menu; ia punya perender untuk bentuk ini.
 */
export const NavItemSchema = z.object({
    route: z.string(),
    label_id: z.string(),
    label_en: z.string(),
    icon: z.string(),
    order: z.number().int(),
    module_code: z.string(),
    /**
     * Lencana hitung `107:218` — dikirim HANYA untuk butir yang manifestnya menyatakan
     * `badge` DAN yang angkanya lebih dari nol. Opsional karena ketiadaannya adalah
     * jawaban yang benar bagi dua puluh satu butir lain, bukan nilai yang hilang.
     */
    badge_count: z.number().int().nonnegative().optional(),
});
export const NavGroupSchema = z.object({
    group: z.string(),
    order: z.number().int(),
    items: z.array(NavItemSchema),
});
export const NavPayloadSchema = z.object({
    surface: z.enum(['console', 'platform', 'mobile']),
    groups: z.array(NavGroupSchema),
});
/** Urutan kelompok sidebar, seperti peta §4 menuliskannya. */
export const NAV_GROUP_ORDER = [
    'OPERATIONS',
    'IMPROVEMENT',
    'KNOWLEDGE',
    'INSIGHT',
    'MANAGE',
    'PLATFORM',
    'GOVERNANCE',
];
//# sourceMappingURL=nav.js.map